<ng-container [ngSwitch]="hasNotification">
  <!-- On -->
  <svg *ngSwitchCase="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13" height="15"
    viewBox="0 0 13 15">
    <g fill="none">
      <g fill="#49BBE6">
        <path d="M0 11L0 10 2 8 2 5C2 2.6 2.8 1.3 5.5 0.5 5.7 0.3 6 0 6.5 0 7 0 7.2 0.5 7.5 0.5 10.2 1.5 11 2.5 11 5 11 5 11 8 11 8L13 10 13 12 8.9 12C9 12.2 9 12.3 9 12.5 9 13.9 7.9 15 6.5 15 5.1 15 4 13.9 4 12.5 4 12.3 4 12.2 4.1 12L2 12 13 12 13 11 0 11Z"
        />
      </g>
    </g>
  </svg>
  <!-- /.On -->

  <!-- Off -->
  <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13" height="16" viewBox="0 0 13 16">
    <g fill="none">
      <g fill="#CDD3D8">
        <path d="M9.6 2.6L11.5 0 13 0 1.5 16 0 16 2.2 13 0 13 0 11 2 9 2 6C2 3.6 2.8 2.3 5.5 1.5 5.7 1.3 6 1 6.5 1 7 1 7.2 1.5 7.5 1.5 8.4 1.8 9.1 2.2 9.6 2.6ZM2.2 13L2.9 12 0 12 0 13 2.2 13ZM10.9 5C11 5.3 11 5.6 11 6 11 6 11 9 11 9L13 11 13 13 8.9 13C9 13.2 9 13.3 9 13.5 9 14.9 7.9 16 6.5 16 5.4 16 4.5 15.3 4.2 14.4L5.2 13 13 13 13 12 5.9 12 10.9 5Z"
        />
      </g>
    </g>
  </svg>
  <!-- /.Off -->
</ng-container>
